// Terms and Privacy Policy version and configuration
export const CURRENT_TERMS_VERSION = '2025-01-15';
export const TERMS_REJECTION_COUNTDOWN_SECONDS = 5;

// Session storage key for OAuth pre-consent
export const OAUTH_TERMS_CONSENT_KEY = 'oauth_terms_consent';

export interface OAuthTermsConsent {
  accepted: boolean;
  timestamp: number;
  version: string;
}
